// Links to firebase account admin@vidatec.com
export default {
  apiKey: "AIzaSyCd1pr__mSKa8ieclPu3CaNaL6dfKuQUtw",
  authDomain: "engage4-dev.firebaseapp.com",
  projectId: "engage4-dev",
  storageBucket: "engage4-dev.firebasestorage.app",
  messagingSenderId: "1068124201228",
  appId: "1:1068124201228:web:d1b38f29fb7988202ce929",
  measurementId: "G-L3HX9BEE66"
};
